import {useEffect} from 'react'

import {useSelector, onlyIfForm} from '../../store.js'
import {
  transferListFormSelector,
  transferListQuerySelector,
} from './transferListFunctions.js'
import {hasTransferFeatureSelector} from '../../data/transfers.js'
import Modals from './Modals/index.js'
import TransferListItemsCount from './TransferListItemsCount.js'
import RefreshTransferList from './RefreshTransferList.js'
import TransferExpandAll from './TransferExpandAll.js'
import TransferSort from './TransferSort.js'
import Actions from './Actions.js'
import ActionsForSelected from './ActionsForSelected.js'
import List from './List.js'
import TransferListOmniBar from './TransferListOmniBar.js'
import TransferFeaturePage from './TransferFeaturePage.js'
import {hasTransferPermissionSelector} from '../../data/me.js'
import NoPermissionsPage from '../NoPermissionsPage.js'
import {showTransferListFilterModal} from './Modals/TransferListFilterModal/transferListFilterModalFunctions.js'
import FiltersButton from '../../common/components/FiltersButton.js'

function TransferListPage({form}) {
  useEffect(() => {
    document.title = 'Inventory Transfers'
  }, [])

  const hasTransferFeature = useSelector(hasTransferFeatureSelector)
  const hasTransferPermission = useSelector(hasTransferPermissionSelector)
  const query = useSelector(transferListQuerySelector)

  if (!hasTransferFeature) {
    return <TransferFeaturePage />
  }

  if (!hasTransferPermission) {
    return <NoPermissionsPage />
  }

  return (
    <div id="iverson-page">
      <Modals />
      <div className="wrap--container">
        <div className="wrap--row">
          <div className="medium-12 columns">
            <div className="wrap--list-header flex--justify padding-top-10 padding-bottom-10">
              <ul className="list list--no-style">
                <TransferListItemsCount />
                <RefreshTransferList />
                <TransferExpandAll />
                <li className="inline-block divider--left">
                  <FiltersButton
                    onClick={() => showTransferListFilterModal({query})}
                  />
                </li>
                <TransferSort />
                {form.selectedTransferIDs.length ? (
                  <ActionsForSelected transferIDs={form.selectedTransferIDs} />
                ) : (
                  <Actions />
                )}
              </ul>
            </div>
          </div>
        </div>
        <div className="wrap--row">
          <div className="medium-12 columns">
            <TransferListOmniBar />
          </div>
        </div>
        <div className="wrap--row margin-top-10">
          <List />
        </div>
      </div>
    </div>
  )
}

export default onlyIfForm(TransferListPage, transferListFormSelector)
